/**
 * Ingen klickhantering här, det är i utils/tabs.js
 */

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tab-list').forEach((wrapper, wrapperIndex) => {
        const tabs = wrapper.querySelector('.tabs')
        const tabContents = wrapper.querySelectorAll('.tab-content')

        let tabIndex = 0
        tabContents.forEach((tabContent) => {
            // Gör varje data-tab unik så att kan ha flera tab-listor på samma sida
            const tabId = `tab-wrapper-${wrapperIndex}-tab-${tabIndex}`
            tabContent.dataset.tab = tabId

            const tab =
                /*html*/
                `<button 
                type="button"
                class="tab px-4 py-2 text-sm md:text-base lg:px-10 border-l border-secondary-200 first:border-l-0 text-secondary-600 hover:text-dark first:rounded-tl-lg last:rounded-tr-lg hover:bg-white transition-colors duration-200 bg-secondary-100 [&.active]:-mb-px z-1 relative [&.active]:bg-white [&.active]:font-medium [&.active]:text-dark [&.active]:border-b-white ${
                    tabIndex === 0 ? 'active' : ''
                }"
                data-tab="${tabId}">
                    ${tabContent.querySelector('.tab-title').textContent}
                </button>`

            if (tabIndex === 0) {
                tabContent.classList.add('active')
            }

            tabs.insertAdjacentHTML('beforeend', tab)
            tabIndex++
        })
    })
})
